
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":".5","width":"30","height":"30","rx":"15","fill":"#E6464C"}}),_c('rect',{attrs:{"x":"7.5","y":"10.582","width":"3.6","height":"17.4","rx":"1.8","transform":"rotate(-45 7.5 10.582)","fill":"#fff"}}),_c('rect',{attrs:{"x":"10.045","y":"22.887","width":"3.6","height":"17.4","rx":"1.8","transform":"rotate(-135 10.045 22.887)","fill":"#fff"}})])
          )
        }
      }
    